<template>
  <el-dialog :visible.sync="show"
             top="6vh"
             width="800px"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false">
    <div class="main-container">
      <div class="media-header">
        {{ languages.media }}
        <div class="dialog-close"
             @click="handleClose">X</div>
      </div>
      <div class="media-container">
        <div class="camera-container">
          <div class="media-title">{{languages.cameraTest}}</div>
          <select v-model="activeCameraIndex"
                  class="video-select"
                  :onchange="openCamera()">
            <option :label="formatStr(item.label)"
                    :value="index"
                    v-for="(item, index) in cameraList"
                    :key="index"></option>
          </select>
          <video ref="video"
                 class="video-container"></video>
          <div v-if="videoLoading"
               class="video-loading">
            <i class="el-icon-loading"></i>
          </div>
        </div>
        <div class="microphone-container">
          <div class="media-title">{{languages.micTest}}</div>
          <el-select v-model="activeMicroPhoneIndex"
                     :onchange="onRecord()"
                     size="mini"
                     class="mic-select">
            <el-option :label="formatStr(item.label)"
                       :value="index"
                       v-for="(item, index) in microPhoneList"
                       :key="index"></el-option>
          </el-select>
          <!-- <el-tag :type="isMicTesting ? 'primary' : 'danger'"
                  :disabled="activeMicroPhoneIndex === ''"
                  size="small"
                  effect="dark"
                  class="mic-button"
                  @click="onRecord">
                  {{ isMicTesting ? languages.play : languages.record }}
                  </el-tag> -->
          <canvas ref="visualizer"
                  class="mic-canvas"></canvas>
          <div class="mic-tip">{{languages.micTip}}</div>
          <audio ref="recordPlayer"
                 class="mic-audio"></audio>
        </div>
        <div class="sound-container">
          <div class="media-title">{{languages.audioTest}}</div>
          <el-scrollbar class="audio-list">
            <div class="audio-item"
                 v-for="(item, index) in audioList"
                 :key="index">
              <div class="audio-name"
                   :class="activeAudioIndex === index ? 'active-audio' : ''">
                {{ formatStr(item.label) }}
              </div>
              <img :src="
                  require(`../../assets/pics/wh/${
                    activeAudioIndex === index && isAudioTesting ? 'stop.png' : 'play.png'
                  }`)
                "
                   @click="audioTest(index)"
                   alt="" />
            </div>
          </el-scrollbar>
          <audio ref="audio"
                 class="play-audio"
                 controls
                 controlsList="nodownload">
            <source src="../../assets/audio/test.mp3"
                    type="audio/mp3" />
          </audio>
        </div>
      </div>
      <div class="result-container">
        <div class="media-title">{{languages.resultConfirm}}</div>
        <div class="result-card"
             v-for="(item, index) in resultList"
             :key="index">
          <img :src="require(`../../assets/pics/wh/${item.icon}.png`)"
               alt=""
               srcset="" />
          <div class="card-name">{{ languages[item.name] }}</div>
          <div class="default-good"
               @click="checkStatus(index,1)">{{languages.checkGood}}</div>
          <div class="default-bad"
               @click="checkStatus(index,-1)">{{languages.checkBad}}</div>
          <div class="good-button"
               v-if="item.status===1">{{languages.checkGood}}</div>
          <div class="bad-button"
               v-if="item.status===-1">{{languages.checkBad}}</div>
          <i class="check-good el-icon-check"
             v-if="item.status===1"></i>
          <i class="check-bad el-icon-check"
             v-if="item.status===-1"></i>
        </div>
        <div class="confirm-button"
             @click="handleConfirm">{{languages.checkConfirm}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      checkList: [],
      cameraList: [],
      audioList: [],
      microPhoneList: [],
      activeCameraIndex: 0,
      cameraIndexNow: -1,
      activeAudioIndex: 0,
      activeMicroPhoneIndex: 0,
      isCameraTesting: false,
      isAudioTesting: false,
      isMicTesting: false,
      testActive: false,
      videoLoading: true,
      mediaRecorder: null,
      resultList: [
        { name: 'camera', status: 0, icon: 'camera' },
        { name: 'microphone', status: 0, icon: 'micro' },
        { name: 'audio', status: 0, icon: 'audio' },
      ],
    };
  },
  props: {
    show: Boolean,
    languages: Object,
  },
  computed: {},
  watch: {
    show (val) {
      if (val) {
        this.getMediaList();
      }
    },
  },
  methods: {
    checkStatus (index, status) {
      this.resultList[index].status = status;
    },
    formatStr (str) {
      if (str.indexOf(':') === -1) return str;
      return str.substring(0, str.lastIndexOf('('));
    },
    getMediaList () {
      this.cameraList = [];
      this.microPhoneList = [];
      this.audioList = [];
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // use this first, or the device label will be empty.
        navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          devices.forEach((device) => {
            switch (device.kind) {
              case 'videoinput':
                this.cameraList.push(device);
                this.resultList[0].status = 1;
                break;
              case 'audiooutput':
                this.audioList.push(device);
                this.resultList[2].status = 1;
                break;
              case 'audioinput':
                this.microPhoneList.push(device);
                this.resultList[1].status = 1;
                break;
              default:
                break;
            }
          });
        });
      }
    },
    handleConfirm () {
      this.$parent.hideMediaDialog(this.resultList);
    },
    async handleClose () {
      await this.closeCamera();
      await this.closeMic();
      await this.stopAudio();
      this.mediaRecorder = null;
      this.activeCameraIndex = 0;
      this.cameraIndexNow = -1;
      this.activeAudioIndex = 0;
      this.activeMicroPhoneIndex = 0;
      this.isCameraTesting = false;
      this.isMicTesting = false;
      this.isAudioTesting = false;
      this.resultList.forEach((item) => { const itm = item; itm.status = 0; });
      this.$parent.dialogMediaVisible = false;
    },
    openCamera () {
      if (!this.show || this.activeCameraIndex === this.cameraIndexNow) return;
      this.cameraIndexNow = this.activeCameraIndex;
      if (window.stream) {
        console.log(window.stream);
        window.stream.getTracks().forEach((track) => track.stop());
      }
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: this.cameraList[this.activeCameraIndex]
              ? { exact: this.cameraList[this.activeCameraIndex].deviceId }
              : undefined,
          },
        })
        .then((stream) => {
          this.$refs.video.srcObject = stream;
          this.$refs.video.play();
        })
        .catch(() => { })
        .finally(() => {
          this.videoLoading = false;
        });
    },
    closeCamera () {
      if (!this.$refs.video) return;
      let stream = this.$refs.video.srcObject;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        stream = null;
      }
    },
    closeMic () {
      const { recordPlayer } = this.$refs;
      if (!recordPlayer) return;
      let stream = recordPlayer.srcObject;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        stream = null;
      }
      recordPlayer.src = '';
    },
    visualize (stream) {
      const audioCtx = new AudioContext();
      const source = audioCtx.createMediaStreamSource(stream);
      const { visualizer } = this.$refs;
      const canvasCtx = visualizer.getContext('2d');
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 2048;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      source.connect(analyser);
      function draw () {
        const WIDTH = visualizer.width;
        const HEIGHT = visualizer.height;

        requestAnimationFrame(draw);

        analyser.getByteTimeDomainData(dataArray);

        canvasCtx.fillStyle = '#f2f7ff';
        canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

        canvasCtx.lineWidth = 5;
        canvasCtx.strokeStyle = '#FFA726';

        canvasCtx.beginPath();

        const sliceWidth = (WIDTH * 1.0) / bufferLength;
        let x = 0;

        for (let i = 0; i < bufferLength; i += 1) {
          const v = dataArray[i] / 128.0;
          const y = (v * HEIGHT) / 2;

          if (i === 0) {
            canvasCtx.moveTo(x, y);
          } else {
            canvasCtx.lineTo(x, y);
          }

          x += sliceWidth;
        }

        canvasCtx.lineTo(visualizer.width, visualizer.height / 2);
        canvasCtx.stroke();
      }
      draw();
    },
    onRecord () {
      // this.isMicTesting = !this.isMicTesting;
      // if (this.isMicTesting) {
      if (this.microPhoneList.length > 0) {
        navigator.mediaDevices
          .getUserMedia({
            audio: {
              deviceId: this.microPhoneList[0].deviceId
                ? { exact: this.microPhoneList[this.activeMicroPhoneIndex].deviceId }
                : undefined,
            },
          })
          .then((stream) => {
            this.visualize(stream);
            // this.mediaRecorder = new MediaRecorder(stream);
            // this.mediaRecorder.addEventListener('dataavailable', (event) => {
            //   this.$refs.recordPlayer.src = URL.createObjectURL(event.data);
            // });
            // this.mediaRecorder.start();
          })
          .catch((error) => {
            console.log(error);
          });
        // } else {
        // this.mediaRecorder.stop();
        // this.mediaRecorder = null;
        // setTimeout(() => {
        //   const { recordPlayer } = this.$refs;
        //   recordPlayer.play();
        // }, 300);
        // }
      }
    },
    audioTest (index) {
      if (this.isAudioTesting) {
        if (this.activeAudioIndex === index) {
          this.isAudioTesting = false;
          this.stopAudio();
        } else {
          this.activeAudioIndex = index;
          this.playAudio();
        }
      } else {
        this.isAudioTesting = true;
        this.activeAudioIndex = index;
        this.playAudio();
      }
    },
    async playAudio () {
      await this.stopAudio();
      const { audio } = this.$refs;
      const { deviceId } = this.audioList[this.activeAudioIndex];
      audio.setSinkId(deviceId);
      audio.play();
    },
    stopAudio () {
      const { audio } = this.$refs;
      audio.pause();
      audio.currentTime = 0;
    },
    audioPlay () {
      this.isAudioTesting = true;
    },
    audioStop () {
      this.isAudioTesting = false;
      const { audio } = this.$refs;
      audio.currentTime = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin-top: -20px;
  padding-bottom: 20px;

  .media-header {
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: linear-gradient(
      90deg,
      rgb(0, 183, 255) 0%,
      rgb(0, 128, 255) 100%
    );
    .dialog-close {
      border-radius: 12px;
      border: 1px solid #fff;
      text-align: center;
      position: absolute;
      right: 16px;
      top: 12px;
      color: #fff;
      height: 24px;
      width: 24px;
      line-height: 24px;
      cursor: pointer;
    }
  }
  .media-container {
    position: relative;
    height: 320px;
    margin: 15px;
    .camera-container,
    .microphone-container,
    .sound-container {
      position: absolute;
      background: #f2f7ff;
      border-radius: 8px;
    }
    .video-loading {
      position: absolute;
      font-size: 30px;
      font-weight: 700;
      top: 150px;
      left: 160px;
    }
    .camera-container {
      width: 390px;
      height: 320px;
      .video-container {
        margin-left: 20px;
        margin-top: 5px;
        width: 350px;
        border-radius: 5px;
      }
    }
    .microphone-container {
      width: 365px;
      right: 0;
      height: 100px;
      .mic-canvas {
        width: 325px;
        height: 40px;
        margin-left: 20px;
        margin-top: 5px;
      }
      .mic-tip {
        position: absolute;
        bottom: 10px;
        font-size: 10px;
        color: #999;
        margin-left: 20px;
      }
      .mic-button {
        cursor: pointer;
        margin-left: 8px;
        width: 60px;
        text-align: center;
      }
    }
    .sound-container {
      width: 365px;
      bottom: 0;
      right: 0;
      height: 205px;
      .audio-list {
        height: 130px;
        .audio-item {
          width: 330px;
          display: flex;
          margin: 13px 10px 13px 20px;
          font-size: 12px;
          .audio-name {
            width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          img {
            margin-top: 1px;
            margin-left: 15px;
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .media-title {
    color: #00b87a;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    margin: 10px 0 0 20px;
  }
  .result-container {
    position: relative;
    display: flex;
    height: 135px;
    background: #f2f7ff;
    border-radius: 8px;
    margin: 0 15px;
    padding-top: 20px;
    padding-left: 10px;
    .media-title {
      position: absolute;
      top: 0px;
      left: 0px;
    }
    .result-card {
      position: relative;
      width: 228px;
      height: 70px;
      margin: 15px 10px;
      background: #fff;
      box-shadow: 0 0 3px rgb(220, 233, 252);
      border-radius: 4px;
      img {
        position: absolute;
        width: 30px;
        left: 50px;
        top: 10px;
      }
      .card-name {
        position: absolute;
        color: #1466de;
        font-size: 10px;
        left: 29px;
        bottom: 10px;
        width: 72px;
        text-align: center;
      }
      .good-button,
      .bad-button,
      .default-good,
      .default-bad {
        width: 90px;
        height: 22px;
        border-radius: 2px;
        text-align: center;
        position: absolute;
        right: 20px;
        font-size: 12px;
        line-height: 22px;
        cursor: pointer;
      }
      .good-button,
      .default-good {
        top: 10px;
      }
      .bad-button,
      .default-bad {
        bottom: 10px;
      }
      .good-button {
        background: #d0e3ff;
        color: #1466de;
        z-index: 1;
      }
      .default-good,
      .default-bad {
        background: #f0f2f5;
        color: #999;
      }
      .bad-button {
        background: #ffe0d4;
        color: #f34500;
        z-index: 1;
      }
      .check-good,
      .check-bad {
        position: absolute;
        right: 20px;
        width: 12px;
        height: 12px;
        color: #fff;
        text-align: center;
        line-height: 12px;
        font-weight: 600;
        font-size: 10px;
        border-radius: 2px 0 2px 0;
        z-index: 2;
      }
      .check-good {
        background: #0080ff;
        top: 19px;
      }
      .check-bad {
        background: #f34500;
        bottom: 10px;
      }
    }
    .confirm-button {
      position: absolute;
      width: 100px;
      height: 24px;
      background: linear-gradient(
        -180deg,
        rgb(0, 183, 255) 0%,
        rgb(0, 128, 255) 100%
      );
      border-radius: 4px;
      text-align: center;
      color: #fff;
      line-height: 24px;
      cursor: pointer;
      bottom: 15px;
      left: 330px;
    }
  }

  .video-select,
  .mic-select {
    outline: none;
    font-size: 12px;
    height: 23px;
    cursor: pointer;
  }
  .video-select {
    max-width: 345px;
    position: absolute;
    left: 23px;
    top: 38px;
    border-radius: 3px;
    box-shadow: 0 0 3px #666;
    z-index: 1;
  }
  .mic-select {
    display: none;
    width: 210px;
    position: absolute;
    right: 10px;
    top: 8px;
  }
  .play-audio {
    margin-left: 20px;
    width: 325px;
    height: 25px;
    outline: none;
    border-radius: 10px;
    box-shadow: 0px 0px 3px #999;
    margin-top: 5px;
    opacity: 0.5;
  }

  .active-audio {
    font-weight: 600;
    color: #1466de;
  }
}
::v-deep .el-dialog {
  border-radius: 8px;
}
audio::-webkit-media-controls-play-button {
  display: none;
}
</style>
